export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    resource: 'Auth',
    action: 'read',
    children: [],
  },
]
